import {TSSchadenfallStatus} from './enums/TSSchadenfallStatus';
import moment = require('../../../node_modules/moment/moment');

export default class TSSchadenfallPreFilterDTO {
    filterUsername: boolean;
    username: string | undefined;
    filterStatus: boolean;
    status: TSSchadenfallStatus[] | undefined;

    constructor(filterUsername: boolean, username: string |undefined, filterStatus: boolean, status: TSSchadenfallStatus[]|undefined) {
        this.filterUsername = filterUsername;
        this.username = username;
        this.filterStatus = filterStatus;
        this.status = status;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/TSSchadenfallPreFilterDTO.ts